module.exports = __webpack_public_path__ + "fonts/VetoSans-BoldItalic.24b0e754.woff";